import { render, staticRenderFns } from "./ResolutionPanel.vue?vue&type=template&id=1cdf3a66&scoped=true"
import script from "./ResolutionPanel.vue?vue&type=script&lang=js"
export * from "./ResolutionPanel.vue?vue&type=script&lang=js"
import style0 from "./ResolutionPanel.vue?vue&type=style&index=0&id=1cdf3a66&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdf3a66",
  null
  
)

export default component.exports